<template>
  <div :class="playerClass">
    <!-- LETRA E VIDEO -->
    <letra-video v-if="getBuilderInfo.aparencia.builder.player_position"></letra-video>
    <!-- LETRA E VIDEO -->
    <div class="col topo">
      <!--<img v-if="logo" :src="logo" alt="">-->
      <!--<div class="logo">{{ site_title_name }}</div>-->
      <div id="jquery_jplayer_1" class="jp-jplayer"></div>
      <div id="jp_container_1" class="jp-audio" role="application" aria-label="media player">

        <!--player-->
        <div class="player" v-if="getCurrent.online">
          <img v-if="getCurrent.song_data.cover" :src="getCurrent.song_data.cover" alt="" class="capa">
          <button class="btn_play_pause jp-play" id="btn_play_pause" role="application" aria-label="media player">
            <i class="fas fa-play"></i>
          </button>
          <div class="cx-musica-banda">
            <div class="musica">{{ getCurrent.playing.title }}</div>
            <div class="cantor-banda">{{ getCurrent.playing.name }}</div>
          </div>
          <div class="cx-volume">
            VOLUME
            <i class="fas fa-volume-up"></i>
            <div id="volume" class="js-volume-bar">
              <input id="slider" type="range">
            </div>
          </div>
        </div>
        <!--quando estiver offline-->
        <div v-if="!getCurrent.online" class="player-off">
          <div class="ico-off"></div>
          Rádio indisponível no momento
          <div class="cx-volume cx-volume-fake">
            VOLUME
            <i class="fas fa-volume-up"></i>
            <div class="volume-fake"></div>
          </div>
        </div>
        <!--player-->
      </div>

      <!--redes sociais-->
      <div class="redes_sociais">
        <label>
          REDES SOCIAIS <br>
          <a :href="getRedeSocial.youtube" v-if="getRedeSocial.youtube" target="_blank"><i
                  class="fab fa-youtube"></i></a>
          <a :href="getRedeSocial.facebook" v-if="getRedeSocial.facebook" target="_blank"><i
                  class="fab fa-facebook-f"></i></a>
          <a :href="getRedeSocial.twitter" v-if="getRedeSocial.twitter" target="_blank"><i
                  class="fab fa-twitter"></i></a>
          <a :href="getRedeSocial.instagram" v-if="getRedeSocial.instagram" target="_blank"><i
                  class="fab fa-instagram"></i></a>
          <a :href="getRedeSocial.whatsapp" v-if="getRedeSocial.whatsapp" target="_blank"><i
                  class="fab fa-whatsapp"></i></a>
          <a :href="getRedeSocial.google" v-if="getRedeSocial.google" target="_blank"><i
                  class="fab fa-google-plus-g"></i></a>
          <a :href="getRedeSocial.sound_cloud" v-if="getRedeSocial.sound_cloud" target="_blank"><i
                  class="fab fa-soundcloud"></i></a>
          <a :href="getRedeSocial.lastfm" v-if="getRedeSocial.lastfm" target="_blank"><i class="fab fa-lastfm"></i></a>
          <a :href="getRedeSocial.snapchat" v-if="getRedeSocial.snapchat" target="_blank"><i
                  class="fab fa-snapchat-ghost"></i></a>
          <a :href="getRedeSocial.flickr" v-if="getRedeSocial.flickr" target="_blank"><i class="fab fa-flickr"></i></a>
          <a :href="getRedeSocial.viber" v-if="getRedeSocial.viber" target="_blank"><i class="fab fa-viber"></i></a>
        </label>
        <label v-if="getRedeSocial.aplicativo">
          APP<br>
          <a :href="getRedeSocial.aplicativo" target="_blank"><i class="fab fa-android"></i></a>
        </label>
      </div>
      <!--redes sociais-->
      <!--se tiver online não mostra botão letra e video-->
      <div class="botoes" v-if="getCurrent.mount != 'live' && getCurrent.online">
        <a id="arrow" class="btns_letra_video collapsed" role="button" data-toggle="collapse"
           data-parent="#accordion"
           href="#cx_letra_video" aria-expanded="true" aria-controls="cx_letra_video">
          <span class="glyphicon glyphicon-triangle-top" id="letraVideo" aria-hidden="true"></span>
          Letra e vídeo da música
        </a>
      </div>
      <!-- LETRA E VIDEO -->
      <letra-video v-if="!getBuilderInfo.aparencia.builder.player_position"></letra-video>
      <!-- LETRA E VIDEO -->
    </div>
  </div>
</template>

<script type="text/javascript">

  import $ from 'jquery';
  import axios from 'axios';
  import rangesliderJs from 'rangeslider-js';
  import VueScrollbar from 'vue2-scrollbar'
  import jplayer from 'jplayer';
  import HelloWorld from "../HelloWorld";
  import ScrollComponent from "../jqueryplugin/ScrollComponent";
  import Semletra from "../jqueryplugin/Semletra";
  import {mapActions, mapGetters} from 'vuex'
  import LetraVideo from "../jqueryplugin/LetraVideo";


  export default {
    name: "Player",
    props: [],
    components: {
      LetraVideo,
      HelloWorld,
      ScrollComponent,
      Semletra,
      VueScrollbar
    },
    data() {
      return {}
    },
    mounted() {
      let self = this;
      if (self.getCurrent.online) {
        let player = $("#jquery_jplayer_1");

        function loadRadio() {
          player.jPlayer("setMedia", {
            title: "Bubble",
            mp3: self.getBuilderInfo.streaming + "?id=" + self.generateId()
          });

        }

        $(document).ready(function () {

          player.jPlayer({
            ready: function (event) {
              loadRadio();
              if (self.getBuilderInfo.autoplay) {
                // player.jPlayer("play");
                player.find('audio')[0]
                    .play()
                    .then(() => {
                    })
                    .catch(() => {
                    });
              }
            },
            swfPath: "../../dist/jplayer",
            supplied: "mp3",
            wmode: "window",
            useStateClassSkin: true,
            autoBlur: false,
            smoothPlayBar: true,
            keyEnabled: true,
            remainingDuration: true,
            preload: "none",
            toggleDuration: true
          });

          let button = $('#btn_play_pause').find('i');
          player.bind($.jPlayer.event.play, function (event) {
            button.removeClass('fa-play');
            button.addClass('fa-pause');
          });
          player.bind($.jPlayer.event.pause, function (event) {
            loadRadio();
            button.removeClass('fa-pause');
            button.addClass('fa-play');
          });
          let volumeCurrent = 0.8;
          rangesliderJs.create(document.getElementById('slider'), {
            min: 0,
            max: 1,
            step: 0.01,
            value: volumeCurrent,
            onSlide: function (value, percent, position) {
              if (value !== volumeCurrent) {
                volumeCurrent = value;
                $('#jquery_jplayer_1').jPlayer('volume', volumeCurrent);
              }
            }
          });
        });
      }
      self.getInfoPlayer();
    },
    methods: {
      ...mapActions(['currentInfo']),
      generateId() {
        var d = new Date();
        var n = d.getTime();
        return Math.floor((Math.random() * n) + 1)
      },
      getInfoPlayer() {
        let self = this;
        setInterval(function () {
          axios.get(self.getBuilderInfo.current).then(function (response) {
            self.currentInfo(response.data)
          });
        }, 10000);
      }
    },
    computed: {
      playerClass: function () {

        if (this.getBuilderInfo.aparencia.builder.player_position == 1) {
          return 'player-bottom';
        }
        return 'player-top';
      },
      getCurrent() {
        return this.$store.getters['getCurrentInfo']
      },
      getBuilderInfo() {
        return this.$store.getters['getBuilderInfo']
      },
      getRedeSocial() {
        return this.$store.getters['getRedeSocial']
      },
      getVideo() {
        if (this.getCurrent.song_data.video) {
          return "https://www.youtube.com/embed/" + this.getCurrent.song_data.video + "?rel=0&amp;controls=0&amp;showinfo=0&modestbranding=1&frameborder=0";
        }
      },
    },
    watch: {
      video: function (val, valold) {
      }
    }
  }
</script>


<style scoped>

  .my-scrollbar {
    width: 35%;
    min-width: 300px;
    max-height: 268px !important;
  }

  /*The Content*/
  .scroll-me {
    min-width: 750px;
  }
</style>


// WEBPACK FOOTER //
// src/components/home/Player.vue